import { render, staticRenderFns } from "./ProductCreate.vue?vue&type=template&id=fd59139c&"
import script from "./ProductCreate.vue?vue&type=script&lang=ts&"
export * from "./ProductCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports